import {
  Box,
  Card,
  makeStyles,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FC, useCallback } from 'react';
import {
  BooleanInput,
  email,
  FormTab,
  ImageField,
  ImageInput,
  minLength,
  regex,
  required,
  SelectInput,
  TabbedForm,
  TextInput,
  useInput,
} from 'react-admin';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import _debounce from 'lodash/debounce';
// import RichTextInput from 'ra-input-rich-text';
import 'easymde/dist/easymde.min.css';
// import SimpleMdeReact from 'react-simplemde-editor/dist/SimpleMdeReact';
// import 'easymde/dist/easymde.min.css';
// import * as MarkdownEditor from '@uiw/react-markdown-editor';
import './index.css';
import BlogHtmlEditor from './blog-html-editor';
import BlogMarkdownEditor from './blog-markdown-editor';
import TitleText from '../common/title-text';
import urlSlug from 'url-slug';
import { Help } from '@material-ui/icons';
import DateTimePicker from 'react-datetime-picker';
import BlogDatePicker from './blog-date-picker';
import ImagesField, { ImagesTypeEnum } from './imagesField/ImagesField';
import { BlogImagesAssetList } from './shared/assets-image-selector';
import BlogSchemaEditor from './blog-schema-editor';

interface Props {
  isBlocked: boolean;
  changeStatus: () => void;
  isShow: boolean;
}

interface SelectCountries {
  id: string;
  name: string;
}
let statuses = ['draft', 'publish', 'personal'];

const BlogGeneralTab: FC<any> = ({
  isBlocked,
  changeStatus,
  isShow,
  ...props
}) => {
  const {
    input: { name, onChange: onChangeSlug, value: slugValue },
    // meta: { touched, error },
    isRequired: isRequiredSlug,
  } = useInput({ ...props, source: 'slug' });
  const {
    input: { onChange: onChangeTitle, value: titleValue },
    // meta: { },
    isRequired: isRequiredTitle,
  } = useInput({ ...props, source: 'title' });

  const parseToSlug = (value) => {
    let parsedValue = String(value)
      .replaceAll(/\s+/g, '-')
      .replaceAll('_', '-')
      .toLowerCase();
    let matched = String(parsedValue).match(/^[\w\d\s-]+$/);
    if (!parsedValue) {
      return '';
    }
    if (!matched?.length) {
      return slugValue;
    }
    let slug = String(matched[0]);
    return slug;
  };

  const handleChangeTitle = (event) => {
    onChangeTitle(event.target.value);
    // let slug = parseToSlug(event.target.value);
    let slug = urlSlug(String(event.target.value), { separator: '-' });
    onChangeSlug(slug);
  };

  const handleChangeSlugByTitle = (event) => {
    let slug = parseToSlug(event.target.value);
    // let slug = urlSlug(String(event.target.value));
    onChangeSlug(slug);
  };

  statuses.sort();
  const countryObject = (countries: Array<string>) => {
    let result = statuses.reduce((agg, item, i) => {
      agg.push({ id: item, name: item });
      return agg;
    }, Array<SelectCountries>());
    return result;
  };

  console.log('Post: ', props.record ? props.record : undefined);
  return (
    <>
      <div className='user-profile-container'>
        <Card>
          <Box padding='2em' width='50%'>
            <Typography variant='h6' gutterBottom className='base-color'>
              Preview Post Image
            </Typography>
            <hr />
            <ImageInput
              source='filesPreviewImage'
              label='Add Image'
              multiple={false}
              className='base-color image-field'
              // validate={validateRequired}
              disabled={isShow}
            >
              <ImageField source='src' title='title' />
            </ImageInput>
          </Box>
        </Card>
        {/* <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
        >
          <Typography gutterBottom className='base-color'>
            Title
          </Typography>
          <TextInput
            id='user-general-input'
            source='title'
            disabled={isShow}
            fullWidth
            className='input-form'
            label=''
          />
        </Box> */}
        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
          mb={2}
          mt={2}
        >
          <Typography gutterBottom className='base-color'>
            Title
          </Typography>
          <TextField
            id='user-general-input'
            value={titleValue}
            disabled={props.isShow}
            fullWidth
            variant='outlined'
            onChange={handleChangeTitle}
            className='input-form'
            label=''
          />
        </Box>
        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
        >
          <Typography gutterBottom className='base-color'>
            <Tooltip
              title={
                'In SEO circles the concept of CNC (human-readable url) is actively used. What does it mean? Look at the URL of this page. It ends with an understandable phrase written in Latin - effektivnaya-raboya-s-seo-blogom, by it you already have an idea of what the article is about. CNCs are very important, because blog promotion in search engines is also due to them: this is the first thing that search bots read, so try to add 1-2 important keys in the URL.'
              }
              placement='top'
            >
              <Help />
            </Tooltip>
            Url Slug
          </Typography>
          <TextField
            id='user-general-input'
            value={slugValue}
            disabled={props.isShow}
            fullWidth
            variant='outlined'
            onChange={handleChangeSlugByTitle}
            className='input-form'
            label=''
          />
        </Box>
        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
        >
          <Typography gutterBottom className='base-color'>
            <Tooltip
              title={'Use for pin articles to one theme and show inside'}
              placement='top'
            >
              <Help />
            </Tooltip>
            Category
          </Typography>
          <TextInput
            id='user-general-input'
            source='category'
            disabled={isShow}
            fullWidth
            className='input-form'
            label=''
          />
        </Box>
        <Box display='flex' justifyContent='flex-start' alignItems='center'>
          <Typography gutterBottom className='base-color'>
            Short description
          </Typography>
          <TextInput
            id='user-general-input'
            source='shortDescription'
            disabled={isShow}
            fullWidth
            style={{ height: 'auto' }}
            className='input-form'
            label=''
            multiline
          />
        </Box>
        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
          marginBottom='1em'
        >
          <Typography className='base-color'>Status</Typography>
          <SelectInput
            id='search-input'
            defaultValue={'draft'}
            source='status'
            choices={countryObject(statuses)}
            className='input-form'
            label=''
            disabled={isShow}
          />
        </Box>
        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
          marginBottom='1em'
        >
          <Typography className='base-color'>Publish Date</Typography>
          <BlogDatePicker source='publishAt' {...props} />
        </Box>

        <Box marginTop='2em' marginBottom='2em'>
          <Box padding='2em'>
            <Typography variant='h6' gutterBottom className='base-color'>
              Meta Tags
            </Typography>
            <hr />
            <Box display='flex' alignItems='center' justifyContent='flex-start'>
              <Typography gutterBottom className='base-color'>
                <Tooltip
                  title={
                    'The optimal length of the title is about 70 characters'
                  }
                  placement='top'
                >
                  <Help />
                </Tooltip>
                Meta Title
              </Typography>

              <TextInput
                className='input-form'
                disabled={isShow}
                fullWidth
                source='metaTitle'
                label='Add a metaTitle'
              />
            </Box>

            <Box display='flex' alignItems='center' justifyContent='flex-start'>
              <Typography gutterBottom className='base-color'>
                <Tooltip
                  title={
                    'The optimal length of the description is about 100-150 characters'
                  }
                  placement='top'
                >
                  <Help />
                </Tooltip>
                Meta Description
              </Typography>
              <TextInput
                source='metaDescription'
                disabled={isShow}
                fullWidth
                className='input-form'
                style={{ height: 'auto' }}
                label=''
                multiline
              />
            </Box>
            <Box display='flex' alignItems='center' justifyContent='flex-start'>
              <Typography gutterBottom className='base-color'>
                <Tooltip
                  title={
                    'They are defined depending on what content is placed on the web page. The tag can be used to highlight key phrases that a potential client can use to find the site in the rendition. Comma-delimited key phrases or words'
                  }
                  placement='top'
                >
                  <Help />
                </Tooltip>
                Meta Keywords
              </Typography>
              <TextInput
                className='input-form'
                disabled={isShow}
                fullWidth
                source='metaKeywords'
                label='Add a metaKeywords'
              />
            </Box>
          </Box>
        </Box>
        <Box
          display='flex'
          // justifyContent='flex-start'
          flexDirection={'column'}
          // alignItems='center'
          width='100%'
        >
          <Box display='flex' alignItems='center' justifyContent='flex-start'>
            <Typography gutterBottom className='base-color'>
              Show HTML (Default Markdown):
            </Typography>
            <BooleanInput label='' source='showHTML' disabled={isShow} />
          </Box>
          <Box>
            <Tabs>
              <TabList>
                <Tab>Markdown</Tab>
                <Tab>HTML</Tab>
                <Tab>Blog Schema</Tab>
              </TabList>
              <TabPanel>
                <BlogMarkdownEditor
                  source='markdown'
                  isShow={isShow}
                  {...props}
                />
              </TabPanel>
              <TabPanel>
                <BlogHtmlEditor source='htmlCode' isShow={isShow} {...props} />
              </TabPanel>
              <TabPanel>
                <BlogSchemaEditor source='schema' isShow={isShow} {...props} />
              </TabPanel>
            </Tabs>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default BlogGeneralTab;
